export default __webpack_public_path__ + "static/media/community.cffdb038.jpeg";